<h5 mat-dialog-title>
    <div class="col-md-12 p-0 row delete-header">
      <div class="col-md-10 p-0">
        Confirm
      </div>
      <div class="col-md-2 p-0 justify-content-end d-flex closePortion">
        <i (click)="handleNo();" class="pi pi-times"></i>
      </div>
    </div>
</h5>
<div class="message" mat-dialog-content>
    <p *ngIf="dialogData?.confirmFlag == 1" class="contentPortion">Are you sure you want to designate <b>{{dialogData?.newPrimary}}</b> as the primary contact ?</p>
    <p *ngIf="dialogData?.confirmFlag == 2" class="contentPortion">You are about to change the primary contact from <b>{{dialogData?.existingPrimary}}</b> to <b>{{dialogData?.newPrimary}}</b></p>
</div>

<div mat-dialog-actions class="float-left">
    <button type="button" class="btn btn-primary mr-3" (click)="onConfirm()">YES</button>
    <button type="button" class="btn btn-secondary" (click)="onDismiss()">CANCEL</button>
</div>